var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.readonly)?_c('interaction-hint',[_vm._v(" Напечатайте ответ на клавиатуре ")]):_vm._e(),_c('v-text-field',{attrs:{"value":_vm.value,"disabled":_vm.readonly,"label":"Ваш ответ"},on:{"input":_vm.answer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }